import HeaderBackground, { BackgroundVariant } from './HeaderBackground';

export default HeaderBackground;

export { BackgroundVariant };
